<template>
  <div class="hibe-init-wrapper">
    <el-form
      ref="formDate"
      :model="formDate"
      :rules="editRules"
      :label-width="`${adaptationVars.formLabelWidth}px`"
      class="demo-ruleForm"
      label-position="left"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="系统层级" prop="level">
            <el-input v-model="formDate.level" placeholder="请输入系统层级"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="公司组织ID" prop="orgid">
            <!-- <el-input v-model="formDate.orgid" placeholder="请输入组织ID"></el-input> -->
            <el-select
              v-model="formDate.orgid"
              placeholder="请选择公司组织ID"
              clearable
              class="auto-width"
            >
              <el-option
                v-for="item in orgOtion"
                :key="item.OrgId"
                :label="item.OrgName"
                :value="item.OrgId"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="系统参数根路径" prop="path">
            <el-input v-model="formDate.path" placeholder="请输入系统参数根路径"></el-input>
            <span class="path-example">例：./path</span>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item>
            <el-button type="primary" @click="handleInit()">确定</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'Index',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 130
  },
  data() {
    let validateLevel = (rule, value, callback) => {
      if (value > 5) {
        callback(new Error('Level不能大于5'))
      } else {
        callback()
      }
    }
    return {
      formDate: {
        level: '',
        orgid: '',
        chain_id: this.$route.query.chainId,
        user_id: String(JSON.parse(localStorage.getItem('cbaas_system_userInfo')).ID),
        path: ''
      },
      editRules: {
        level: [{ required: true, message: '请输入系统层级', trigger: 'blur' }],
        orgid: [{ required: true, message: '请选择公司组织ID', trigger: 'blur' }],
        path: [{ required: true, message: '请输入系统参数根路径', trigger: 'blur' }]
      },
      orgOtion: [],
      adaptationVars: {
        formLabelWidth: 130
      }
    }
  },
  mounted() {
    this.getOptions()
  },
  methods: {
    getOptions() {
      this.$apis.chain
        .getChainOrgList({ limit: 1000, offset: 0, chainId: this.$route.query.chainId })
        .then(res => {
          if (res.data && res.data.items) {
            let hasObj = {}
            this.orgOtion = res.data.items.reduce((result, cur) => {
              if (!hasObj[cur.OrgId]) {
                hasObj[cur.OrgId] = true
                result.push(cur)
              }
              return result
            }, [])
          }
        })
    },
    handleInit() {
      this.$refs.formDate.validate(valid => {
        if (valid) {
          this.$apis.hibe.init(this.formDate).then(res => {
            if (res) {
              localStorage.setItem('keyspath', this.removePrefix(res.data.keyspath))
              localStorage.setItem('paramspath', this.removePrefix(res.data.paramspath))
              localStorage.setItem('path', this.removePrefix(this.formDate.path))
              localStorage.setItem('orgid', this.formDate.orgid)
              this.$emit('getPath')
              this.$message.success('初始化成功!')
            }
          })
        }
      })
    },

    changeText() {
      this.isChangeText = !this.isChangeText
      this.isChangeText
        ? (this.proclaimedTextEncryption = this.proclaimedText)
        : (this.proclaimedTextEncryption = '********')
    },
    methodChange(val) {
      localStorage.setItem('method', val)
    },
    removePrefix(str) {
      var colonIndex = str.indexOf(':')

      // 使用substring()方法截取冒号后一位的字符串
      var result = str.substring(colonIndex + 1)

      return result
    }
  }
}
</script>

<style scoped lang="scss">
.hibe-init-wrapper {
  .path-example {
    color: var(--base-color-danger);
  }

  .el-row {
    margin: 0 calc(0px - var(--base-size-16));

    .el-col {
      padding: 0 var(--base-size-16);
    }
  }
}
</style>
